<div class="card p-3 mb-3">
  <div class="d-flex justify-content-between">
    <div>
      <div class="d-flex align-items-center">
        <h4 class="mr-1 font-weight-bolder mb-0">
          {{ report?.companyFixedBenefitName }}
        </h4>
        <span class="badge badge-pill badge-warning" *ngIf="report?.status === ExpenseReportStatus.Pending">
          {{ report?.statusLabel | translate }}
        </span>
        <span class="badge badge-pill badge-success" *ngIf="report?.status === ExpenseReportStatus.Approved">
          {{ report?.statusLabel | translate }}
        </span>
        <span class="badge badge-pill badge-danger" *ngIf="report?.status === ExpenseReportStatus.Rejected">
          {{ report?.statusLabel | translate }}
        </span>
        <span class="badge badge-pill badge-primary" *ngIf="report?.status === ExpenseReportStatus.SentToHr">
          {{ report?.statusLabel | translate }}
        </span>
      </div>
    </div>

    <div class="text-right">
      <h4 class="font-weight-bolder mb-0">
        {{ report?.expenseValue | number: '1.2-2' }} {{ 'DETAILS.UNIT1' | translate }}
      </h4>
      <div class="text-muted small" *ngIf="report?.totalAmountWithTax && report?.totalAmountWithTax !== report?.expenseValue">
        {{ 'EXPENSE_REPORT.HISTORY.TOTAL_WITH_TAX' | translate }}
        {{ report?.totalAmountWithTax | number: '1.2-2' }} {{ 'DETAILS.UNIT1' | translate }}
      </div>
      <!-- Company tax (Net distribution: full tax). Hidden for Gross/Cat_1 (companyTax = 0). -->
      <div class="text-muted small" *ngIf="report?.companyTax > 0">
        {{ 'EXPENSE_REPORT.HISTORY.COMPANY_TAX' | translate }}
        {{ report?.companyTax | number: '1.2-2' }} {{ 'DETAILS.UNIT1' | translate }}
      </div>
    </div>
  </div>

  <hr/>

  <div class="d-flex justify-content-between align-items-center">
    <div>
      <div class="text-dark small mb-1">
        {{ 'EXPENSE_REPORT.HISTORY.DATE' | translate }} {{ report?.createdAt | localizedDate }}
      </div>
      <div class="text-dark small mb-1" *ngIf="report?.files?.length > 0">
        {{ 'EXPENSE_REPORT.HISTORY.FILES' | translate }} {{ report?.files?.length }}
      </div>
    </div>
  </div>

  <div *ngIf="report?.status === ExpenseReportStatus.Rejected && report?.reviewMessage" class="mt-2">
    <div class="alert alert-danger mb-0 p-2">
      <div class="text-dark small font-weight-bold">{{ 'EXPENSE_REPORT.HISTORY.REJECTION_REASON' | translate }}</div>
      <div class="text-dark small">{{ report?.reviewMessage }}</div>
    </div>
  </div>

  <div *ngIf="report?.status === ExpenseReportStatus.Approved && report?.reviewMessage" class="mt-2">
    <div class="alert alert-success mb-0 p-2">
      <div class="text-dark small font-weight-bold">{{ 'EXPENSE_REPORT.HISTORY.APPROVAL_MESSAGE' | translate }}</div>
      <div class="text-dark small">{{ report?.reviewMessage }}</div>
    </div>
  </div>

  <div *ngIf="report?.reviewedAt" class="mt-1">
    <div class="text-muted small">
      {{ 'EXPENSE_REPORT.HISTORY.REVIEWED_AT' | translate }} {{ report?.reviewedAt | localizedDate }}
      <span *ngIf="report?.reviewedByUserName"> - {{ report?.reviewedByUserName }}</span>
    </div>
  </div>
</div>
